import { render, staticRenderFns } from "./Caracteristica.vue?vue&type=template&id=03fb2f84&scoped=true"
import script from "./Caracteristica.vue?vue&type=script&lang=js"
export * from "./Caracteristica.vue?vue&type=script&lang=js"
import style0 from "./Caracteristica.vue?vue&type=style&index=0&id=03fb2f84&prod&lang=css"
import style1 from "./Caracteristica.vue?vue&type=style&index=1&id=03fb2f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fb2f84",
  null
  
)

export default component.exports